import { createApp, h } from 'vue'
import type { App } from 'vue'
import { IApplication } from '../common/IApplication'
import store from '../store'
import questionParser from './question-parser'
import { vuetify } from '../packs/application'
import AppBreadcrumb from '../apps/client/components/atoms_molecules/AppBreadcrumb.vue'
import VideoWrapper from '../apps/client/components/atoms_molecules/VideoWrapper.vue'
import VueApexCharts from 'vue3-apexcharts'
import { initSentry } from '../lib/sentry'

// Track if Sentry has been initialized (only once per page)
let sentryInitialized = false

export default (app: IApplication) => {
  if (app.stores) {
    app.stores.forEach(storeModule => store.registerModule(storeModule.key, storeModule.module))
  }

  (<any>window).questionParser = questionParser

  const elementId = app.elementId
  if (!document.getElementById(elementId)) return

  // Create Vue 3 app instance
  const vueApp: App = createApp({
    render: () => h(app.rootComponent)
  })

  // Install plugins using Vue 3 API
  vueApp.use(store)
  vueApp.use(vuetify)
  vueApp.use(VueApexCharts)

  // Register global components
  vueApp.component('AppBreadcrumb', AppBreadcrumb)
  vueApp.component('video-wrapper', VideoWrapper)
  // Note: 'apexchart' is automatically registered by VueApexCharts plugin (line 29)

  if (app.i18n) {
    vueApp.use(app.i18n)
  }

  if (app.vueRouter) {
    vueApp.use(app.vueRouter)
  }

  if (app.dependencies) {
    app.dependencies.forEach(dependency => vueApp.use(dependency.plugin, dependency.options))
  }

  // Provide data globally if needed
  if (app.data) {
    vueApp.provide('dataStore', app.data.dataStore)
  }

  // Initialize Sentry for error tracking (only once per page, production only)
  if (!sentryInitialized) {
    initSentry({
      app: vueApp,
      router: app.vueRouter,
    })
    sentryInitialized = true
  }

  // Mount the app
  vueApp.mount(`#${elementId}`)

  return vueApp
}
